import { merge, property } from 'lodash';
import axios from 'axios';

import pagination from 'config/pagination';

import { SURVEY_TYPE_COLLECTION_PATH } from '../config/EntityCollectionPathMap';
import { generateApiError } from '../utils/apiErrorMessages';
import {
  jsonApiHeaders,
  jsonApiFieldList,
  buildApiV2Url,
  toSurveyListSearchFilter,
  toSurveyListStatusFilter,
  toSurveyListSortDirection,
  toIsOnlyFavoriteFilter,
  onlyCommonSurveysFilter,
} from '../utils/apiUtils';
import { mapSurveyListFromApiModel } from '../dataMapper/surveyListDataMapper';

const getSurveys = ({
  sortOrder,
  sortBy,
  statuses,
  search,
  pageNumber = 0,
  onlyFavorites = false,
  showConnectSurveys = false,
}) => {
  const params = merge({}, jsonApiFieldList.surveyListItem, {
    sort: toSurveyListSortDirection(sortOrder, sortBy),
    filter: {
      ...toSurveyListSearchFilter(search),
      ...toSurveyListStatusFilter(statuses),
      ...(!showConnectSurveys && onlyCommonSurveysFilter),
    },
    page: {
      limit: pagination.limit,
      offset: pageNumber * pagination.limit,
    },
    ...toIsOnlyFavoriteFilter(onlyFavorites),
  });

  return axios
    .get(buildApiV2Url(SURVEY_TYPE_COLLECTION_PATH, params), {
      headers: jsonApiHeaders,
    })
    .catch(generateApiError())
    .then(property('data'))
    .then(mapSurveyListFromApiModel);
};

export default getSurveys;
